import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumb.css';

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  if (location.pathname === '/') return null;

  const breadcrumbMap = {
    'gallery': 'Art Gallery',
    'auctions': 'Auction Gallery',
    'custom-request': 'Custom Artwork Request',
    'login': 'Login',
    'about': 'About',
    'painting': 'Painting Details'
  };

  return (
    <nav aria-label="breadcrumb" className="breadcrumb-nav">
      <div className="container">
        <ol className="breadcrumb-list" itemScope itemType="https://schema.org/BreadcrumbList">
          <li className="breadcrumb-item" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <Link to="/" itemProp="item">
              <span itemProp="name">Home</span>
            </Link>
            <meta itemProp="position" content="1" />
          </li>
          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            const displayName = breadcrumbMap[name] || name;
            
            // Skip ID segments for cleaner breadcrumbs
            if (name.match(/^\d+$/) && index > 0) return null;

            return (
              <li 
                key={name + index} 
                className={`breadcrumb-item ${isLast ? 'active' : ''}`}
                itemProp="itemListElement" 
                itemScope 
                itemType="https://schema.org/ListItem"
              >
                {isLast ? (
                  <span itemProp="name">{displayName}</span>
                ) : (
                  <Link to={routeTo} itemProp="item">
                    <span itemProp="name">{displayName}</span>
                  </Link>
                )}
                <meta itemProp="position" content={index + 2} />
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;